import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingScreen = () => {
  return (
    <Box
      sx={{
        height: '80vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <CircularProgress color="success" size={60} />
      <Typography variant="h6" color="textSecondary">
        Preparing your experience...
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
